module.exports = __webpack_public_path__ + "img/zahorodskaolena.05483b08.jpg";